export default __webpack_public_path__ + "static/media/addPotion.1db0c540.mp3";